/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Search_None_HintInputs */

const cs_documents_search_none_hint = /** @type {(inputs: Documents_Search_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkuste jiný název nebo jeho část. Hledá se v názvech souborů i složek.`)
};

const en_documents_search_none_hint = /** @type {(inputs: Documents_Search_None_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try another name or part of it. File and folder names are searched.`)
};

/**
* | output |
* | --- |
* | "Try another name or part of it. File and folder names are searched." |
*
* @param {Documents_Search_None_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_none_hint = /** @type {((inputs?: Documents_Search_None_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_None_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_none_hint(inputs)
	return cs_documents_search_none_hint(inputs)
});